function getConfig() {
  let config = JSON.parse(
    (document.getElementById("configScript") as any).innerHTML
  );

  config.googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY
    ? [process.env.REACT_APP_GOOGLE_API_KEY]
    : config.googleApiKey;

  config.applicationInsightsKey = process.env.REACT_APP_APPLICATION_INSIGHTS_KEY
    ? [process.env.REACT_APP_APPLICATION_INSIGHTS_KEY]
    : config.applicationInsightsKey;

  config.apiUrl = process.env.REACT_APP_API_URL || config.apiUrl;
  config.appUrl = process.env.REACT_APP_APP_URL || config.appUrl;

  config.reCaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || config.reCaptchaSiteKey;
  config.stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || config.stripePublishableKey;

  // Beta flag: prefer environment variable, fallback to existing config value, default false
  const betaEnv = process.env.REACT_APP_BETA;
  if (typeof betaEnv !== "undefined") {
    // Accept "true"/"false" (case-insensitive) or "1"/"0"
    const normalized = String(betaEnv).trim().toLowerCase();
    config.beta = normalized === "true" || normalized === "1";
  } else if (typeof (config as any).beta === "undefined") {
    (config as any).beta = true;
  } else if ((config as any).beta === "#{beta}#") {
    (config as any).beta = true;
  }

  return config;
}

export default getConfig;